import 'react-app-polyfill/ie11'
import 'core-js/es/symbol'
import 'core-js/es/object/values'
import 'core-js/es/object/keys'
import 'core-js/es/object/entries'
import 'core-js/es/string/repeat'
import 'core-js/es/array/from'
import 'core-js/es/array/includes'

if (!Object.entries) {
    Object.entries = obj => {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i) // preallocate the Array

        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]]
        return resArray
    }
}
